import React, { useState, useCallback, useEffect } from 'react';
import { TextField } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

function NumberField(props) {
  const { label } = props.attribute;

  const intl = useIntl();

  const { mode } = props;

  useEffect(() => {
    setValue(![null, ''].includes(props?.value) ? props.value?.toString() : '');
  }, [props.value]);

  const [value, setValue] = useState(props?.value?.toString() || null);
  const handleChange = useCallback((newValue) => {
    const updatedValue = ![null, ''].includes(newValue) ? newValue : null;
    setValue(updatedValue);
    props.handleChange(updatedValue);
  }, []);
  return (
    <div className="w100">
      <TextField
        placeholder={getTranslatedText(intl, 'common.placeholder.enterValue')}
        label={label}
        value={value}
        onChange={handleChange}
        inputMode={mode}
        type="number"
      />
    </div>
  );
}

export default NumberField;
